import { useState, useEffect, useRef } from 'react';

type UseIconRotationReturn = {
    rotation: number;
    startRotation: () => void;
    stopRotation: () => void;
};

export const useIconRotation = (intervalMs: number = 1000): UseIconRotationReturn => {
    const [rotation, setRotation] = useState<number>(0);
    const [isRotating, setIsRotating] = useState<boolean>(false);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);

    const startRotation = () => {
        if (isRotating) {
            return;
        }

        setIsRotating(true);
        setRotation(180);

        intervalRef.current = setInterval(() => {
            setRotation(prev => (prev + 180) % 360);
        }, intervalMs);
    };

    const stopRotation = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
        setIsRotating(false);
        setRotation(0);
    };

    useEffect(() => {
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, []);

    return {
        rotation,
        startRotation,
        stopRotation,
    };
};
